import RidingResult from './RidingResult'
import MultiSeatResult from './MultiSeatResult'
import ProvincialResult from './ProvincialResult'
import Province from './Province'
import RegionalResult from './RegionalResult'
import Region from './Region'

export default class NationalResult extends MultiSeatResult {
  protected _provincialResultsMap: { [key: string]: ProvincialResult }
  protected _regionalResultsMap: { [key: string]: RegionalResult }

  public constructor(ridingResults: RidingResult[]) {
    super(ridingResults)
    this._provincialResultsMap = this.buildProvincialResultsMap(ridingResults)
    this._regionalResultsMap = this.buildRegionalResultsMap(ridingResults)
  }

  protected buildProvincialResultsMap(
    ridingResults: RidingResult[]
  ): { [key: string]: ProvincialResult } {
    const map: { [key: string]: ProvincialResult } = {}
    Province.allProvincesArray().forEach((province): void => {
      map[province.key] = new ProvincialResult(ridingResults, province)
    })

    return map
  }

  protected buildRegionalResultsMap(
    ridingResults: RidingResult[]
  ): { [key: string]: RegionalResult } {
    const map: { [key: string]: RegionalResult } = {}
    Region.allRegionsArray().forEach((region): void => {
      map[region.key] = new RegionalResult(ridingResults, region)
    })

    return map
  }

  public regionalResults(): RegionalResult[] {
    return Object.values(this._regionalResultsMap)
  }

  public resultForRegion(region: Region): RegionalResult {
    return this._regionalResultsMap[region.key]
  }

  public ridingResultsByRegion(region: Region): RidingResult[] {
    return this._regionalResultsMap[region.key].ridingResults()
  }

  public provincialResults(): ProvincialResult[] {
    return Object.values(this._provincialResultsMap)
  }

  public clone(): NationalResult {
    const ridingResults: RidingResult[] = []

    for (const result of this.ridingResults()) {
      ridingResults.push(result.clone())
    }

    return new NationalResult(ridingResults)
  }
}
